import React, { useRef, useEffect, useState, MutableRefObject, SyntheticEvent } from "react";
import { Dropdown } from "semantic-ui-react";

import ErrorMessage from "react-lib/apps/common/ErrorMessage";
import ModConfirm from "react-lib/apps/common/cnmi/ModConfirm";
import { useIntl } from "react-intl";
type CardDuplicateDrugOrdersProps = {
  duplicateReasonsOptions: {
    key: string;
    text: string;
    value: string | number;
  }[];
  duplicateList: {
    drug_name: string;
    duplicated_details: string;
    first_duplicated_item: string;
    duplicated_note: string;
    product: string[];
  }[];
  onClose: Function;
  onApprove: Function;
};

const CardDuplicateDrugOrders: React.FunctionComponent<
  CardDuplicateDrugOrdersProps
> = (props) => {
  const intl = useIntl();
  const [isConfirm, setIsConfirm] = useState<boolean>(true);
  const [duplicateNote, setDuplicateNote] = useState<any>("");
  const [errorMessage, setErrorMessage] = useState<any>(null);
  const [options, setOptions] = useState<any[]>([])
  const [isLoading, setIsLoading] = useState<boolean>(false)

  const dropdownRef = useRef() as MutableRefObject<any>;

  useEffect(() => {
    setOptions(props.duplicateReasonsOptions || [])
  }, [props.duplicateReasonsOptions])

  const handleConfirm = async () => {
    if(isLoading){
      return;
    }

    if (!isConfirm) {
      setIsConfirm(true);
      setTimeout(() => {
        dropdownRef.current?.ref?.current?.click();
      }, 200);
    } else {
      const note = options.find((item) => item.value === duplicateNote)?.text || "";

      const firstNote = props.duplicateList[0].duplicated_note;

      if (!note && !firstNote) {
        return setErrorMessage("กรุณาระบุ เหตุผลที่สั่งยาซ้ำ");
      }

      setIsLoading(true);

      await props.onApprove?.({
        duplicated_note: note || firstNote,
      });

      setIsLoading(false);
    }
  };

  const handleAddOptions = (e: SyntheticEvent, v: any) => {
    setOptions([...options, { key: v.value, text: v.value, value: v.value }]);
  };

  return (
    <div>
      <ModConfirm
        openModal={true}
        titleName={"พบรายการสั่งยาซ้ำตาม Generic Name"}
        titleColor={"orange"}
        size="small"
        approveButtonText={isConfirm ? "ใช่" : "ยืนยัน"}
        denyButtonText={isConfirm ? "ยกเลิก" : "ไม่"}
        approveButtonLoading={isLoading}
        onApprove={handleConfirm}
        onDeny={props.onClose}
        onCloseWithDimmerClick={props.onClose}
        content={
          <>
            <ErrorMessage error={errorMessage} />
            {(props.duplicateList || []).map((item: any) => (
              <div className="ui" style={{ whiteSpace: "pre-wrap", lineHeight: 1.75 }}>
                <div dangerouslySetInnerHTML={{ __html: item.drug_name }} />
                <div dangerouslySetInnerHTML={{ __html: item.duplicated_details }} />
              </div>
            ))}

            <br />
            {isConfirm ? (
              <Dropdown
                ref={dropdownRef}
                placeholder="กรุณาระบุเหตุผลการสั่งซ้ำ"
                value={duplicateNote}
                selection={true}
                fluid
                search
                options={options}
                allowAdditions
                onAddItem={handleAddOptions}
                onChange={(e, v) => setDuplicateNote(v.value)}
              />
            ) : (
              <strong>{intl.formatMessage({ id: "ต้องการสั่งหรือไม่" })}</strong>
            )}
          </>
        }
      />
    </div>
  );
};

export default React.memo(CardDuplicateDrugOrders);
